import { useState, useEffect } from 'react';
import './App.css';

import { useDispatch } from 'react-redux';
import { USER_LOGIN_SUCCESS } from './redux/constants/auth';
// Dependencies
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// All Components
import Footer from './components/Footer';
import Header from './components/Header';
import LoginLoader from './components/LoginLoader';
import Sidebar from './components/Sidebar';
import ApiSettings from './pages/apiSettings';

import GroupInfo from './pages/groupInfo';
import MemberDetails from './pages/memberDetails';
import WebhookSettings from './pages/webhookSettings';
import SheetSettings from './pages/sheetSettings';
import MessageSettings from './pages/messageSettings';

// All Pages

function App() {
	const [logingIn, setLoggingIn] = useState(false);

	const dispatch = useDispatch();
	useEffect(() => {
		tryLogin();
	});

	const tryLogin = () => {
		const gm_user_item = localStorage.getItem('_gm_usr');
		let gm_user = JSON.parse(gm_user_item);

		if (!gm_user && !gm_user?.gmBackendToken) {
			let intervalId = setInterval(() => {
				const gm_user_item = localStorage.getItem('_gm_usr');
				const gm_user = JSON.parse(gm_user_item);
				if (gm_user_item && gm_user?.gmBackendToken) {
					clearInterval(intervalId);
					setTimeout(() => {
						setLoggingIn((val) => true);
						dispatch({ type: USER_LOGIN_SUCCESS, payload: gm_user });
					}, 500);
				}
			}, 1000);
		} else {
			setLoggingIn((val) => true);
		}
	};

	return (
		<Router>
			{!logingIn ? (
				<LoginLoader setLoggingIn={setLoggingIn} />
			) : (
				<>
					<Sidebar />
					<div className='mailContentRight'>
						<Header />
						<div className='dashboardContent'>
							<Switch>
								{/* <Route path='/' exact component={''} /> */}
								<Route path='/api-settings' exact component={ApiSettings} />
								{/* <Route path='/group-info' exact component={GroupInfo} /> */}
								<Route
									path='/webhook-settings'
									exact
									component={WebhookSettings}
								/>
								<Route
									path='/message-settings'
									exact
									component={MessageSettings}
								/>
								<Route path='/sheet-settings' exact component={SheetSettings} />
								<Route path='/' exact component={GroupInfo} />
								<Route
									path='/member-details/:leadid'
									exact
									component={MemberDetails}
								/>
							</Switch>
						</div>
						<Footer />
					</div>
				</>
			)}
		</Router>
	);
}

export default App;
